import { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import styles from '../RecordVideo.module.css';

const ExitPageModal = ({ onLeavePage = () => null }) => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextPath, setNextPath] = useState('');

  useEffect(() => {
    const unblock = history.block((location) => {
      setNextPath(location.pathname);
      setIsModalOpen(true);
      return false; // Block navigation
    });

    return () => unblock(); // Clean the lock when  disassembling
  }, [history]);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleConfirmLeave = () => {
    setIsModalOpen(false);
    onLeavePage();
    if (nextPath) {
      history.block(() => {}); // Temporarily unlock
      history.push(nextPath); // Navigate
    }
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      classes={{ paper: styles.previewDialog }}
    >
      <DialogTitle>Preview of the recording</DialogTitle>
      <DialogContent>
        <Typography>
          {' '}
          Recording in progress. Are you sure you want to continue without saving the interaction?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="gray">
          Go back
        </Button>
        <Button type="submit" onClick={handleConfirmLeave}>
          Exit without saving
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExitPageModal;
